import { CampaignType } from 'generated-graphql/types';
import { SourcingSharedSetupApplicationFormData } from 'modules/sourcing-shared/forms';

type GetSourcingSharedCampaignTypeDefaultValueInput = {
  applicationFormData: SourcingSharedSetupApplicationFormData | null;
  hasAtsJobId: boolean;
  hasAtsJobApplicationUrl: boolean;
};
// NO ATS: CampaignType.RequestCvOutreach
// AtsJobApplicationUrl Found: CampaignType.AtsJobApplicationUrlOutreach
// ATS & Supported ATS: CampaignType.RequestCvOutreach
// ATS & No AtsJobApplicationUrl: CampaignType.CustomJobApplicationUrlOutreach
export const getSourcingSharedCampaignTypeDefaultValue = ({
  applicationFormData,
  hasAtsJobId,
  hasAtsJobApplicationUrl
}: GetSourcingSharedCampaignTypeDefaultValueInput): CampaignType => {
  if (applicationFormData?.campaignType) {
    return applicationFormData.campaignType;
  }

  if (hasAtsJobApplicationUrl) {
    return CampaignType.AtsJobApplicationUrlOutreach;
  }

  if (!hasAtsJobId) {
    return CampaignType.RequestCvOutreach;
  }

  return CampaignType.CustomJobApplicationUrlOutreach;
};
